(function () {
  function wrapLetters(el) {
    var text = el.textContent.trim();
    if (!text) return;
    el.innerHTML = '';
    var i = 0;
    text.split('').forEach(function (ch) {
      var span = document.createElement('span');
      span.className = 'sig-letter';
      span.style.setProperty('--i', i);
      span.textContent = ch === ' ' ? ' ' : ch;
      el.appendChild(span);
      i++;
    });
  }

  function init() {
    var els = document.querySelectorAll('[data-signature]');
    if (!els.length) return;
    els.forEach(wrapLetters);
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { observer.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
